module.exports = __webpack_public_path__ + "img/banner.7499a5c2.jpg";